const modalToggle = () => {
  const modal = document.getElementById("AnnouncementModal");
  const openBtn = document.getElementById("btn-announcement-bar-modal-opener");
  const closeBtns = modal.querySelectorAll(".announcement-modal__close-button");

  if (!modal || !openBtn) return;

  const closeModal = () => {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    openBtn.focus();
  };

  const openModal = () => {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    const focusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    focusable?.focus();
  };

  const toggleModal = (event) => {
    event.preventDefault();

    if (modal.classList.contains("is-open")) {
      closeModal();
    } else {
      openModal();
    }
  };

  // Toggle modal
  openBtn.addEventListener("click", toggleModal);

  // Close modal
  closeBtns.forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  // Close with Esc key
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });
};

document.addEventListener("DOMContentLoaded", modalToggle);